import { render, staticRenderFns } from "./CertificationUploader.vue?vue&type=template&id=4bf472cb&scoped=true&"
import script from "./CertificationUploader.vue?vue&type=script&lang=js&"
export * from "./CertificationUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf472cb",
  null
  
)

export default component.exports